import { i18n } from "../i18n";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import { commonMenuItems } from "@/game_profiles/common";

const { t } = i18n.global;

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "branch" } },
  { component: "ConfSection", props: { name: "basic" } },
];

const join = () => {
  window.open(t("ngp/settings/section/hell_let_loose_wiki/link"), "_blank", "noopener,noreferrer");
};

const extra = () => {
  window.open("https://cdn.g-portal.com/HLL_RCON.zip");
};

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/hell_let_loose_wiki",
    joinFn: join,
  },
  extraHeaderButton: {
    buttonTextKey: "ngp/settings/section/hell_let_loose/rcon_tool_download",
    btnFn: extra,
  },
});
